var render = function render(_c,_vm){return _c('div',{staticClass:"dir-button-cont",style:({margin: _vm.props.margin})},[_vm._l((20),function(n){return [_vm._t('slot-'+n)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }